import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {GenerateTableParseResponse, PARSER_CONFIG_TYPES} from "../_models/parser-config-template";


export abstract class ModelUploadOptions {
    // placeholder for models that require options.
    // options generation is delegated to a component tailored for the model type.
}

export type ComponentModelUpsertType = 'by_name';

export type EventModelUpsertType = 'unique_property';

export class HeaderType {
    // NOTE: renaming any of these values will break templates that use them!
    // TODO add order to these (ie. can change the order in the options list)

    // Header keys

    // single use headers
    public readonly START_DATE: string = 'start-date';
    public readonly END_DATE: string = 'end-date';

    // multiple use headers
    public readonly UNUSED: string = 'ignore';
    public readonly PROPERTY: string = 'property';
    public readonly COMPONENT: string = 'component';

    public static descriptions(): { [key: string]: string } {
        const ht = new HeaderType();
        const d: any = {};
        d[ht.START_DATE] = 'Start Date';
        d[ht.END_DATE] = 'End Date';

        d[ht.UNUSED] = 'Ignore this column';
        d[ht.PROPERTY] = 'Property';
        d[ht.COMPONENT] = 'Component';
        return d;
    }
}

export class HeaderAssociation {
    // csv column name
    source: string;
    // target feature type
    target_type: string;
    // id associated with the given target type (eg. ComponentType or ConstantProperty id )
    override_id: string | null;
}

export class ModelSelectionUploadOption {
    name: string;
    parser_type: PARSER_CONFIG_TYPES;
    require_options: boolean;
}

export interface UploadModelFormData {
    parser_type: PARSER_CONFIG_TYPES;
}

export class EventModelOptions extends ModelUploadOptions {
    update_only: boolean = true;
    // parser and file option fields
    upsert_type: EventModelUpsertType = 'unique_property';
    event_type: string;
    unique_property: string;
    use_column_indexes: boolean = false;
    skip_rows: number = 0;

    // fields associated for headers
    start_date_header: string;
    end_date_header: string;
    property_headers: string[][] = [];
    component_type_headers: string[][] = [];
}

export class ComponentModelOptions extends ModelUploadOptions {
    update_only: boolean = true;
    // parser and file option fields
    upsert_type: ComponentModelUpsertType = 'by_name';
    component_type: string;
    use_column_indexes: boolean = false;
    skip_rows: number = 0;

    // fields associated for headers
    start_date_header: string;
    end_date_header: string;
    name_header: string;
    property_headers: string[][] = [];
    component_type_headers: string[][] = [];
}

export interface GenerateTableUploadResponse {
    message: string;
    parse_response: GenerateTableParseResponse;
}

export const model_selection_options: ModelSelectionUploadOption[] = [{
    name: 'Event', parser_type: 'event', require_options: true,
}, {
    name: 'Component', parser_type: 'component', require_options: true,
}
];

export async function openUploadModelFormComponent(dialog: MatDialog, data: UploadModelFormData) {
    const {UploadModelFormDialogComponent} = await import("../forms/upload-model-form/upload-model-form-dialog.component");
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = ['default-form-dialog', 'model-upload-form-dialog'];
    dialogConfig.data = data
    dialog.open(UploadModelFormDialogComponent, dialogConfig);
}
